import { Calendar, Clock, MapPin, User, Users, Gift } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";

const GroupMentoringCards = ({ mentoringPrograms, onClick }) => {
  const { id } = useSelector((state) => state.auth);

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-3xl font-bold text-gray-800 mb-2 text-center">
        Group Mentoring Programs
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Join expert-led group mentoring sessions to accelerate your professional
        growth
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {mentoringPrograms.map((program, index) => {
          const isFull = program.seatsAvailable === 0;
          const isUserRegistered =
            program.registeredUsers?.includes(id) || false;
          return (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-blue-300 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="relative">
                {/* <img
                  src={program.imageUrl}
                  alt={`${program.mentorName}'s mentoring program`}
                  className="w-full h-48 object-cover"
                /> */}
                <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full text-sm font-medium shadow-sm border">
                  {program.frequency}
                  {/* · {program.sessions} Sessions */}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="bg-indigo-100 rounded-full p-2 mr-4">
                    <User size={24} className="text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">
                      Mentor: {program.mentorName}
                    </h3>
                  </div>
                </div>

                <p className="text-gray-700 mb-6">{program.description}</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center text-gray-700">
                    <Calendar size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">Start Date</span>
                      <p className="font-medium">{program.startDate}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Calendar size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">End Date</span>
                      <p className="font-medium">{program.endDate}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Clock size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">Schedule</span>
                      <p className="font-medium">{program.dateTime}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <MapPin size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">Timezone</span>
                      <p className="font-medium">{program.timezone}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Users size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">Target Users</span>
                      <p className="font-medium">{program.targetUsers}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <Gift size={18} className="mr-2 text-indigo-500" />
                    <div>
                      <span className="text-sm text-gray-500">What user will get out of this?</span>
                      <p className="font-medium">{program.whatUserWillGetOutOfThis}</p>
                    </div>
                  </div>

                </div>

                <div className="flex flex-wrap justify-between items-end pt-4 border-t border-gray-100">
                  <div>
                    <div className="text-2xl font-bold text-indigo-600 mb-1">
                      ${program.price}
                      <span className="text-sm font-normal text-gray-500">
                        {" "}
                        per mentee
                      </span>
                    </div>

                    <div className="flex items-center">
                      <Users size={16} className="mr-1 text-gray-500" />
                      <span className="text-gray-600 text-sm">
                        {program.seatsAvailable} seats available
                      </span>
                    </div>
                  </div>

                  {isFull ? (
                    <button
                      disabled
                      className="px-4 py-2 bg-gray-400 text-white font-medium rounded-lg cursor-not-allowed"
                    >
                      Fully Booked
                    </button>
                  ) : isUserRegistered ? (
                    <button
                      disabled
                      className="px-4 py-2 bg-blue-300 text-white font-medium rounded-lg cursor-not-allowed"
                    >
                      Already Registered
                    </button>
                  ) : (
                    <button
                      onClick={() => onClick(program)}
                      className="px-4 py-2 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors"
                    >
                      Register Now
                    </button>
                  )}
                </div>

                {isFull && (
                  <div className="mt-3 text-sm text-gray-600">
                    This mentoring program is currently full. Check back later
                    or explore other programs.
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupMentoringCards;
